import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import API from "../../services/api";

// ✅ Place Order from Cart
export const placeOrderFromCart = createAsyncThunk(
  "order/placeOrderFromCart",
  async ({ userId, totalPrice, addressId, paymentMethod = 'cod', orderType = 'home_delivery' }, thunkAPI) => {
    try {
      const orderData = {
        user_id: userId,
        total_price: totalPrice.toString(),
        address_id: addressId,
        payment_method: paymentMethod,
        order_type: orderType
      };
      
      console.log("Placing order with data:", orderData);
      const res = await API.post("/orders/place_order", orderData);
      console.log("Place order response:", res.data);
      return res.data;
    } catch (err) {
      console.error("Place order error:", err.response?.data);
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || err.response?.data?.error || "Failed to place order"
      );
    }
  }
);

const orderSlice = createSlice({
  name: "order",
  initialState: {
    loading: false,
    error: null,
    orderSuccess: false,
    orderId: null,
  },
  reducers: {
    clearOrderStatus: (state) => {
      state.error = null;
      state.orderSuccess = false;
      state.orderId = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // ✅ Place Order from Cart
      .addCase(placeOrderFromCart.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.orderSuccess = false;
      })
      .addCase(placeOrderFromCart.fulfilled, (state, action) => {
        state.loading = false;
        state.orderSuccess = true;
        state.orderId = action.payload?.order_id || action.payload?.data?.order_id;
        state.error = null;
      })
      .addCase(placeOrderFromCart.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.orderSuccess = false;
      });
  },
});

export const { clearOrderStatus } = orderSlice.actions;
export default orderSlice.reducer;